import { Stack, Typography } from '@mui/material';

import { ColorsRaw } from '@/ui/theme/colors-raw';

export function ProjectVenueCardContentBox({
  topLeftValue,
  topLeftLabel,
  bottomLeftValue,
  bottomLeftLabel,
  scoreComponent,
}: {
  topLeftValue?: string;
  topLeftLabel?: string;
  bottomLeftValue?: string;
  bottomLeftLabel?: string;
  scoreComponent: React.ReactNode;
}) {
  return (
    <Stack
      sx={{
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
        border: '1px solid',
        borderRadius: 2,
        borderColor: ColorsRaw.anthracite.Anthracite_4,
        paddingTop: 2,
        paddingBottom: 2.5,
        paddingX: 2,
      }}
    >
      {topLeftValue && topLeftLabel && (
        <Stack>
          {topLeftValue && topLeftLabel && (
            <LeftTextGroup leftValue={topLeftValue} leftLabel={topLeftLabel} />
          )}
          {bottomLeftValue && bottomLeftLabel && (
            <LeftTextGroup
              leftValue={bottomLeftValue}
              leftLabel={bottomLeftLabel}
            />
          )}
        </Stack>
      )}
      {scoreComponent}
    </Stack>
  );
}

function LeftTextGroup({
  leftValue,
  leftLabel,
}: {
  leftValue?: string;
  leftLabel?: string;
}) {
  return (
    <Stack sx={{ flexDirection: 'row', alignItems: 'flex-end', gap: '5px' }}>
      <Typography
        sx={{
          fontSize: '1.5rem',
          fontWeight: 900,
          color: ColorsRaw.basic.White,
          lineHeight: '2rem',
        }}
      >
        {leftValue}
      </Typography>
      <Typography
        sx={{
          fontSize: '1rem',
          fontWeight: 700,
          opacity: 0.7,
          color: ColorsRaw.basic.Cream,
        }}
      >
        {leftLabel}
      </Typography>
    </Stack>
  );
}
